module.exports = __webpack_public_path__ + "img/4.385e2761.jpg";